import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { LoadingService } from "@coso/loading";
import { DialogComponent, DialogType } from "@coso/utility";
import { forkJoin, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HighAvailabilityModes, IConfigurationHolder } from "../../../models/auto-generated";
import { AUserPermissionsService } from "../../../services/a-user-permissions.service";
import { LicenseService } from "../../../services/license.service";
import { SettingsStore } from "../../../stores/settings.store";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone:false,
  templateUrl: "./failover.component.html",
  styleUrls: ["./failover.component.scss"]
})
export class FailoverComponent implements OnInit, OnDestroy, AfterViewInit {
  HighAvailabilityModes = HighAvailabilityModes;

  private unsubscribe = new Subject<void>();
  @ViewChild(NgForm) public formRef: NgForm;

  settings$: Observable<IConfigurationHolder>;
  isFailOverAllowed$: Observable<boolean>;
  readonly: boolean;

  constructor(
    public loadingService: LoadingService,
    public userPermissionsService: AUserPermissionsService,
    private settingsStore: SettingsStore,
    private modalService: NgbModal,
    private licenseService: LicenseService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  ngAfterViewInit(): void {
    // more info: https://angular.io/errors/NG0100
    setTimeout(() => {
      this.formRef.form.markAllAsTouched();
      this.formRef.form.statusChanges.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.settingsStore.updateValidity("failover", this.formRef.valid);
      });
    }, 0);
  }

  ngOnInit(): void {
    this.isFailOverAllowed$ = this.licenseService.isFailOverAllowed();
    this.settings$ = this.settingsStore.settings$;
    forkJoin([this.userPermissionsService.hasLimitedAccess$, this.userPermissionsService.isCustomerAgent$]).subscribe(
      ([hasLimitedAccess, isCustomerAgent]) => (this.readonly = hasLimitedAccess || isCustomerAgent)
    );
  }

  onHighAvailabilityModeChanged(current: IConfigurationHolder) {
    if (current.highAvailabilityMode === HighAvailabilityModes.FailoverBackup) {
      const modalRef = this.modalService.open(DialogComponent, {
        keyboard: false,
        ariaLabelledBy: "modalTitle"
      });
      modalRef.componentInstance.options = {
        titleText: "Configuration Sharing in Backup Instances",
        type: DialogType.Warning,
        contentText:
          "By switching to backup instance mode, the current configuration will be automatically overridden with the one from the main instance. This means that you may lose your settings and connections.",
        rightButtons: [
          {
            label: "OK",
            type: "button",
            class: "btn btn-primary",
            onClick: () => modalRef.dismiss()
          }
        ],
        onClose: () => modalRef.dismiss()
      };
    }
    this.updateSettings(current);
  }

  updateSettings(current: IConfigurationHolder) {
    this.settingsStore.updateSettings(current);
  }
}
